module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_7042.6a5e2a35.png";